(() => {
  const marker = 'dominator-review-20260624';
  if (window[marker]) return;
  window[marker] = true;

  const all = (selector, root = document) => Array.from(root.querySelectorAll(selector));
  const one = (selector, root = document) => root.querySelector(selector);
  const escapeHtml = (value = '') => String(value).replace(/[&<>"']/g, (char) => ({
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  })[char]);

  const richSourceFor = (root, attr, value) => {
    if (!root || !value) return null;
    return all('[' + attr + ']', root).find((node) => node.getAttribute(attr) === value) || null;
  };

  const preserveScroll = (fn) => {
    const x = window.scrollX;
    const y = window.scrollY;
    const active = document.activeElement;
    fn();
    requestAnimationFrame(() => {
      if (active && typeof active.focus === 'function') active.focus({ preventScroll: true });
      if (Math.abs(window.scrollY - y) > 2) window.scrollTo(x, y);
    });
    window.setTimeout(() => {
      if (Math.abs(window.scrollY - y) > 2) window.scrollTo(x, y);
    }, 140);
  };

  const syncHeroSecondary = (category) => {
    const hero = one('[data-home-hero]');
    const secondary = hero ? one('[data-home-hero-secondary]', hero) : null;
    if (!secondary) return;
    secondary.textContent = category === 'pickleball' ? 'Plan pickleball court' : 'Plan a court';
    secondary.href = '/pages/court-planner';
  };

  const installMobileControlGuard = () => {
    if (document.getElementById("dominator-mobile-control-guard")) return;
    const style = document.createElement("style");
    style.id = "dominator-mobile-control-guard";
    style.textContent = `@media (max-width: 760px) {
  body .site-header .menu-button,
  body.template-index .site-header .menu-button,
  body.template-page .site-header .menu-button,
  body.template-product .site-header .menu-button,
  body.template-search .site-header .menu-button,
  body.template-cart .site-header .menu-button {
    display: none !important;
    visibility: hidden !important;
    opacity: 0 !important;
    pointer-events: none !important;
  }

  html body:not(.support-open):not(.template-cart) .thumb-nav {
    display: block !important;
    visibility: visible !important;
    opacity: 1 !important;
    pointer-events: auto !important;
    width: 64px !important;
    height: 64px !important;
    min-height: 64px !important;
  }

  html body.template-product:not(.support-open):not(.template-cart) .thumb-nav {
    right: 12px !important;
    bottom: calc(14px + env(safe-area-inset-bottom)) !important;
    width: 64px !important;
    height: 64px !important;
    min-height: 64px !important;
    z-index: 72 !important;
  }

  html body:not(.support-open):not(.template-cart) .thumb-nav__main {
    display: grid !important;
    visibility: visible !important;
    opacity: 1 !important;
    pointer-events: auto !important;
    width: 64px !important;
    height: 64px !important;
    min-height: 64px !important;
  }

  html body.template-product:not(.support-open):not(.template-cart) .thumb-nav .thumb-nav__main {
    width: 64px !important;
    height: 64px !important;
    min-height: 64px !important;
  }

  html body:not(.support-open):not(.template-cart) .thumb-nav__item {
    display: inline-flex !important;
    visibility: visible !important;
    opacity: 0 !important;
    pointer-events: none !important;
    width: 74px !important;
    height: 64px !important;
    min-height: 64px !important;
  }

  html body:not(.support-open):not(.template-cart) .thumb-nav.is-open .thumb-nav__item {
    opacity: 1 !important;
    pointer-events: auto !important;
  }

  html body:not(.support-open):not(.template-cart) .thumb-nav__children[hidden] {
    display: none !important;
    visibility: hidden !important;
    opacity: 0 !important;
    pointer-events: none !important;
    width: 0 !important;
    height: 0 !important;
    min-height: 0 !important;
  }

  html body:not(.support-open):not(.template-cart) .thumb-nav__children:not([hidden]) {
    display: block !important;
    visibility: visible !important;
    opacity: 1 !important;
    pointer-events: auto !important;
  }

  html body:not(.support-open):not(.template-cart) .thumb-nav__children a,
  html body:not(.support-open):not(.template-cart) .thumb-nav__children button {
    display: grid !important;
    visibility: visible !important;
    opacity: 1 !important;
    pointer-events: auto !important;
    width: 60px !important;
    height: 60px !important;
    min-height: 60px !important;
  }

  body.template-product .pdp-hero {
    display: flex !important;
    flex-direction: column !important;
    gap: 0 !important;
    padding-top: 0 !important;
  }

  body.template-product .pdp-media {
    order: -3 !important;
    width: 100% !important;
    max-width: 100% !important;
    margin: 0 auto !important;
    padding: 0 !important;
  }

  body.template-product .pdp-media__main {
    position: relative !important;
    width: 100% !important;
    min-height: 0 !important;
    height: clamp(340px, 94vw, 430px) !important;
    max-height: 430px !important;
    aspect-ratio: auto !important;
    border-radius: 0 0 18px 18px !important;
    overflow: hidden !important;
    cursor: grab !important;
    touch-action: pan-y !important;
    background: #050506 !important;
  }

  body.template-product .pdp-media__main > img,
  body.template-product .pdp-media__main > video {
    width: 100% !important;
    height: 100% !important;
    object-fit: contain !important;
  }

  body.template-product .pdp-media__thumbs,
  body.template-product .pdp-hero-thumbs {
    display: none !important;
    visibility: hidden !important;
    pointer-events: none !important;
    height: 0 !important;
    margin: 0 !important;
    padding: 0 !important;
    overflow: hidden !important;
  }

  body.template-product .buy-box {
    order: -2 !important;
    position: relative !important;
    z-index: 3 !important;
    width: min(100%, calc(100% - 24px)) !important;
    margin: 14px auto 22px !important;
    padding: 20px !important;
    border-radius: 10px !important;
    box-shadow: 0 20px 44px rgba(0, 0, 0, 0.18) !important;
  }

  body.template-product .pdp-hero-caption strong {
    display: none !important;
  }
}`;
    document.head.appendChild(style);
  };

  const installPdpAnchorLegibilityGuard = () => {
    if (document.getElementById('dominator-pdp-anchor-legibility-20260623')) return;
    const style = document.createElement('style');
    style.id = 'dominator-pdp-anchor-legibility-20260623';
    style.textContent = `body.template-product .pdp-anchor-nav {
  top: var(--sticky-header-offset, 42px) !important;
  min-height: 56px !important;
  height: 56px !important;
  max-height: none !important;
  gap: 10px !important;
  padding: 8px clamp(12px, 2vw, 28px) !important;
  overflow-x: auto !important;
  overflow-y: hidden !important;
  scroll-snap-type: x mandatory !important;
  scrollbar-width: thin !important;
  background: #050506 !important;
  border-bottom: 1px solid rgba(255, 255, 255, 0.16) !important;
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.28) !important;
  mask-image: none !important;
  -webkit-mask-image: none !important;
}
body.template-product .pdp-anchor-nav a {
  min-height: 40px !important;
  height: 40px !important;
  max-height: none !important;
  padding: 0 18px !important;
  border-radius: 6px !important;
  font-size: clamp(0.78rem, 0.82vw, 0.95rem) !important;
  line-height: 1 !important;
  scroll-snap-align: start !important;
  white-space: nowrap !important;
}
body.template-product #product-decisions,
body.template-product #product-compare,
body.template-product #inspect,
body.template-product #social-proof,
body.template-product #reviews,
body.template-product #questions {
  scroll-margin-top: calc(var(--sticky-header-offset, 42px) + 76px) !important;
}
@media (max-width: 760px) {
  body.template-product .pdp-anchor-nav {
    min-height: 54px !important;
    height: 54px !important;
    grid-auto-columns: minmax(132px, max-content) !important;
    gap: 8px !important;
    padding: 7px 14px !important;
  }
  body.template-product .pdp-anchor-nav a {
    min-height: 40px !important;
    height: 40px !important;
    padding: 0 14px !important;
    font-size: 12px !important;
  }
}`;
    document.head.appendChild(style);
  };

  const bindHomeModeAftercare = () => {
    all('[data-category-tab]').forEach((tab) => {
      if (tab.dataset.reviewModeAftercareBound === 'true') return;
      tab.dataset.reviewModeAftercareBound = 'true';
      tab.addEventListener('click', () => {
        window.setTimeout(() => syncHeroSecondary(tab.dataset.categoryTab || 'hoops'), 0);
      });
    });
  };

  const removeRedundantCompareCardToggles = (root = document) => {
    all('[data-product-comparison] [data-compare-expand]', root).forEach((button) => {
      button.remove();
    });
  };

  const bindCompareExpandAll = () => {
    removeRedundantCompareCardToggles();

    all('[data-compare-expand-all]').forEach((button) => {
      if (button.dataset.reviewCompareAllBound === 'true') return;
      button.dataset.reviewCompareAllBound = 'true';
      button.addEventListener('click', (event) => {
        event.preventDefault();
        const section = button.closest('[data-product-comparison]') || document;
        const cards = all('[data-product-compare-card], .comparison-card', section);
        const shouldOpen = section.dataset.compareExpanded !== 'true';
        section.dataset.compareExpanded = String(shouldOpen);
        section.classList.toggle('is-expanded', shouldOpen);
        cards.forEach((card) => {
          const details = one('[data-compare-details]', card);
          if (details) {
            details.hidden = !shouldOpen;
            details.setAttribute('aria-hidden', String(!shouldOpen));
          }
          all('[data-compare-extra]', card).forEach((row) => {
            row.hidden = !shouldOpen;
            row.setAttribute('aria-hidden', String(!shouldOpen));
          });
          const cardButton = one('[data-compare-expand]', card);
          if (cardButton) {
            cardButton.remove();
          }
        });
        var showLabel = button.getAttribute('data-compare-show-label') || 'Show all features';
        var hideLabel = button.getAttribute('data-compare-hide-label') || 'Hide all features';
        button.textContent = shouldOpen ? hideLabel : showLabel;
        button.setAttribute('aria-expanded', String(shouldOpen));
      });
    });
  };

  const bindProductMediaSwipe = () => {
    all('[data-product-media-gallery]').forEach((gallery) => {
      if (gallery.dataset.reviewMobileSwipeBound === 'true') return;
      gallery.dataset.reviewMobileSwipeBound = 'true';
      const main = one('[data-product-media-main]', gallery);
      const buttons = all('[data-media-src]', gallery);
      if (!main || buttons.length < 2) return;
      gallery.dataset.mobileSwipeGallery = 'true';
      let startX = 0;
      let startY = 0;

      const activeIndex = () => Math.max(0, buttons.findIndex((button) => button.classList.contains('is-active') || button.getAttribute('aria-pressed') === 'true'));
      const showAt = (nextIndex) => {
        const index = (nextIndex + buttons.length) % buttons.length;
        const button = buttons[index];
        if (!button) return;
        const src = button.dataset.mediaSrc;
        const label = button.dataset.mediaLabel || 'Product media';
        const title = button.dataset.mediaTitle || label;
        const image = one('img', main);
        if (image && src) {
          image.src = src;
          image.alt = title;
        }
        const captionLabel = one('[data-media-caption-label]', main);
        const captionTitle = one('[data-media-caption-title]', main);
        if (captionLabel) captionLabel.textContent = label;
        if (captionTitle) captionTitle.textContent = title;
        buttons.forEach((item) => {
          const active = item === button;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-pressed', String(active));
        });
        button.click();
      };
      const finishSwipe = (clientX, clientY) => {
        const dx = clientX - startX;
        const dy = clientY - startY;
        if (Math.abs(dx) < 36 || Math.abs(dx) < Math.abs(dy) * 1.25) return;
        showAt(activeIndex() + (dx < 0 ? 1 : -1));
      };

      main.addEventListener('touchstart', (event) => {
        const touch = event.changedTouches?.[0];
        if (!touch) return;
        startX = touch.clientX;
        startY = touch.clientY;
      }, { passive: true });
      main.addEventListener('touchend', (event) => {
        const touch = event.changedTouches?.[0];
        if (!touch) return;
        finishSwipe(touch.clientX, touch.clientY);
      }, { passive: true });
      main.addEventListener('pointerdown', (event) => {
        if (event.pointerType === 'mouse') return;
        startX = event.clientX;
        startY = event.clientY;
      });
      main.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse') return;
        finishSwipe(event.clientX, event.clientY);
      });
    });
  };

  const bindProductReadingSurfaceSticky = () => {
    if (!document.body.classList.contains('template-product')) return;
    if (document.body.dataset.reviewReadingSurfaceStickyBound === 'true') return;
    document.body.dataset.reviewReadingSurfaceStickyBound = 'true';
    const targets = all('#product-decisions, #product-compare, #inspect');
    if (!targets.length || !('IntersectionObserver' in window)) return;
    const activeTargets = new Set();
    const sync = () => {
      document.body.classList.toggle('product-reading-surface-visible', activeTargets.size > 0);
    };
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && entry.intersectionRatio > 0.08) activeTargets.add(entry.target.id);
        else activeTargets.delete(entry.target.id);
      });
      sync();
    }, {
      rootMargin: '-120px 0px -34% 0px',
      threshold: [0, 0.08, 0.2]
    });
    targets.forEach((target) => observer.observe(target));
  };

  const bindHeaderDropdowns = () => {
    all('.site-nav__dropdown').forEach((dropdown) => {
      if (dropdown.dataset.reviewDropdownBound === 'true') return;
      dropdown.dataset.reviewDropdownBound = 'true';
      let closeTimer = null;
      const closeOthers = () => {
        all('.site-nav__dropdown').forEach((other) => {
          if (other !== dropdown) {
            other.open = false;
            other.dataset.reviewClickOpen = 'false';
          }
        });
      };
      const openDropdown = () => {
        window.clearTimeout(closeTimer);
        closeOthers();
        dropdown.open = true;
      };
      const closeDropdown = () => {
        window.clearTimeout(closeTimer);
        closeTimer = window.setTimeout(() => {
          dropdown.open = false;
          dropdown.dataset.reviewClickOpen = 'false';
        }, 180);
      };
      dropdown.addEventListener('mouseenter', openDropdown);
      dropdown.addEventListener('mouseleave', closeDropdown);
      dropdown.addEventListener('focusin', openDropdown);
      one('summary', dropdown)?.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        const clickedOpen = dropdown.dataset.reviewClickOpen === 'true';
        if (dropdown.open && clickedOpen) {
          dropdown.open = false;
          dropdown.dataset.reviewClickOpen = 'false';
          return;
        }
        openDropdown();
        dropdown.dataset.reviewClickOpen = 'true';
      });
      dropdown.addEventListener('focusout', () => {
        closeTimer = window.setTimeout(() => {
          if (!dropdown.contains(document.activeElement)) {
            dropdown.open = false;
            dropdown.dataset.reviewClickOpen = 'false';
          }
        }, 180);
      });
      dropdown.addEventListener('toggle', () => {
        if (!dropdown.open) return;
        closeOthers();
      });
    });
    if (document.documentElement.dataset.reviewDropdownOutsideBound !== 'true') {
      document.documentElement.dataset.reviewDropdownOutsideBound = 'true';
      document.addEventListener('click', (event) => {
        if (event.target.closest('.site-nav__dropdown')) return;
        all('.site-nav__dropdown[open]').forEach((dropdown) => {
          dropdown.open = false;
          dropdown.dataset.reviewClickOpen = 'false';
        });
      });
      document.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;
        all('.site-nav__dropdown[open]').forEach((dropdown) => {
          dropdown.open = false;
          dropdown.dataset.reviewClickOpen = 'false';
        });
      });
    }
  };


  const bindSpecDecisionPanel = () => {
    all('[data-spec-decision-panel]').forEach((panel) => {
      if (panel.dataset.reviewSpecDecisionBound === 'true') return;
      panel.dataset.reviewSpecDecisionBound = 'true';
      const label = one('[data-spec-decision-answer-label]', panel);
      const title = one('[data-spec-decision-answer-title]', panel);
      const copy = one('[data-spec-decision-answer-copy]', panel);
      const media = one('[data-spec-decision-answer-media]', panel);
      const answerRich = one('[data-spec-decision-answer-rich]', panel);
      const thumbs = one('[data-spec-media-thumbs]', panel);
      const primaryLink = one('[data-spec-decision-primary-link]', panel);
      const secondaryLink = one('[data-spec-decision-secondary-link]', panel);
      const supportButton = one('[data-spec-decision-support-button]', panel);

      const syncThumbVisibility = () => {
        if (!thumbs) return;
        const thumbCount = all('[data-spec-media-thumb]', thumbs).length;
        const hideThumbs = thumbCount <= 1;
        thumbs.hidden = hideThumbs;
        thumbs.setAttribute('aria-hidden', String(hideThumbs));
        thumbs.classList.toggle('is-single-item', hideThumbs);
      };

      const setMedia = (src, mediaTitle) => {
        if (!src || !media) return;
        media.src = src;
        media.alt = mediaTitle || title?.textContent || '';
        all('[data-spec-media-thumb]', thumbs || panel).forEach((thumb) => {
          const selected = thumb.dataset.specMediaSrc === src;
          thumb.classList.toggle('is-active', selected);
          thumb.setAttribute('aria-pressed', String(selected));
        });
        syncThumbVisibility();
      };

      const bindThumbs = () => {
        all('[data-spec-media-thumb]', thumbs || panel).forEach((button) => {
          if (button.dataset.reviewSpecThumbBound === 'true') return;
          button.dataset.reviewSpecThumbBound = 'true';
          button.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopImmediatePropagation();
            preserveScroll(() => setMedia(button.dataset.specMediaSrc || '', button.textContent.trim()));
          }, true);
        });
      };

      const renderGallery = (key, fallbackSrc, mediaTitle) => {
        if (!thumbs) {
          setMedia(fallbackSrc || '', mediaTitle || '');
          return;
        }
        const source = richSourceFor(panel, 'data-spec-gallery-source', key);
        if (source && source.innerHTML.trim()) {
          thumbs.innerHTML = source.innerHTML;
        } else if (fallbackSrc) {
          thumbs.innerHTML = `
            <button class="is-active" type="button" data-spec-media-thumb data-spec-media-src="${escapeHtml(fallbackSrc)}" aria-pressed="true">
              <img src="${escapeHtml(fallbackSrc)}" loading="lazy" width="180" height="120" alt="">
              <span>${escapeHtml(mediaTitle || 'Detail')}</span>
            </button>
          `;
        } else {
          thumbs.innerHTML = '';
        }

        if (fallbackSrc) {
          const matchingThumb = all('[data-spec-media-thumb]', thumbs)
            .find((thumb) => thumb.dataset.specMediaSrc === fallbackSrc);
          if (matchingThumb) {
            thumbs.prepend(matchingThumb);
          } else {
            thumbs.insertAdjacentHTML('afterbegin', `
              <button type="button" data-spec-media-thumb data-spec-media-src="${escapeHtml(fallbackSrc)}" aria-pressed="false">
                <img src="${escapeHtml(fallbackSrc)}" loading="lazy" width="180" height="120" alt="">
                <span>${escapeHtml(mediaTitle || 'Detail')}</span>
              </button>
            `);
          }
        }

        all('[data-spec-media-thumb]', thumbs).forEach((thumb, index) => {
          const selected = index === 0;
          thumb.classList.toggle('is-active', selected);
          thumb.setAttribute('aria-pressed', String(selected));
        });
        syncThumbVisibility();
        bindThumbs();
        const selectedThumb = one('[data-spec-media-thumb].is-active', thumbs) || one('[data-spec-media-thumb]', thumbs);
        if (selectedThumb) setMedia(selectedThumb.dataset.specMediaSrc || fallbackSrc || '', selectedThumb.textContent.trim() || mediaTitle || '');
        else setMedia(fallbackSrc || '', mediaTitle || '');
      };

      const setRichAnswer = (key, fallback) => {
        if (!answerRich) return;
        const source = richSourceFor(panel, 'data-spec-rich-source', key);
        if (source) answerRich.innerHTML = source.innerHTML;
        else if (fallback) answerRich.innerHTML = '<p>' + fallback + '</p>';
      };

      const activate = (button) => {
        if (!button) return;
        all('[data-spec-decision-option]', panel).forEach((candidate) => {
          const selected = candidate === button;
          candidate.classList.toggle('is-active', selected);
          candidate.setAttribute('aria-selected', String(selected));
        });
        const data = button.dataset;
        if (label) label.textContent = data.specLabel || '';
        if (title) title.textContent = data.specTitle || '';
        if (copy) copy.textContent = data.specCopy || '';
        if (primaryLink) {
          primaryLink.textContent = (data.specPrimaryLabel || primaryLink.textContent).toUpperCase();
          if (data.specPrimaryUrl) primaryLink.href = data.specPrimaryUrl;
        }
        if (secondaryLink) {
          secondaryLink.textContent = (data.specSecondaryLabel || secondaryLink.textContent).toUpperCase();
          if (data.specSecondaryUrl) secondaryLink.href = data.specSecondaryUrl;
        }
        if (supportButton) {
          supportButton.textContent = (data.specSupportLabel || supportButton.textContent).toUpperCase();
          supportButton.dataset.supportIntent = data.specSupportIntent || supportButton.dataset.supportIntent || 'buying';
        }
        renderGallery(data.specRich || '', data.specMedia || '', data.specTitle || '');
        setRichAnswer(data.specRich || '', data.specCopy || '');
      };

      const options = all('[data-spec-decision-option]', panel);
      options.forEach((button) => {
        button.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopImmediatePropagation();
          preserveScroll(() => activate(button));
        }, true);
      });

      bindThumbs();

      activate(options.find((button) => button.classList.contains('is-active')) || options[0]);
    });
  };

  const bindProductQuestionPanel = () => {
    all('[data-product-question-bank]').forEach((bank) => {
      if (bank.dataset.reviewQuestionPanelBound === 'true') return;
      bank.dataset.reviewQuestionPanelBound = 'true';
      const label = one('[data-product-question-answer-label]', bank);
      const title = one('[data-product-question-answer-title]', bank);
      const copy = one('[data-product-question-answer-copy]', bank);
      const answerRich = one('[data-product-question-answer-rich]', bank);
      const input = one('[data-product-question-input]', bank);
      const submit = one('[data-product-question-submit]', bank);
      const empty = one('[data-empty-question]', bank);
      const followup = one('[data-question-followup]', bank);
      const suggestions = all('[data-product-question-item]', bank);

      const activate = (button) => {
        if (!button || button.hidden) return;
        all('[data-product-question-item]', bank).forEach((candidate) => {
          const selected = candidate === button;
          candidate.classList.toggle('is-active', selected);
          candidate.setAttribute('aria-pressed', String(selected));
        });
        if (label) label.textContent = button.dataset.questionLabel || 'Answer';
        if (title) title.textContent = button.dataset.questionTitle || button.textContent.trim();
        if (copy) copy.textContent = button.dataset.questionAnswer || '';
        if (answerRich) {
          const source = richSourceFor(bank, 'data-question-rich-source', button.dataset.questionRich || '');
          answerRich.innerHTML = source ? source.innerHTML : '<p>' + (button.dataset.questionAnswer || '') + '</p>';
          all('p', answerRich).forEach((paragraph) => {
            paragraph.innerHTML = paragraph.innerHTML.replace(/(^|<br\s*\/?>)\s*([•-]\s*)([^:<]+:)/gi, '$1$2<strong>$3</strong>');
          });
        }
        if (followup) followup.hidden = true;
      };

      const filterQuestions = () => {
        const query = (input?.value || '').trim().toLowerCase();
        const tokens = query.split(/\s+/).filter((token) => token.length > 1);
        let firstVisible = null;
        let visibleCount = 0;
        suggestions.forEach((button) => {
          const haystack = [
            button.dataset.questionLabel,
            button.dataset.questionTitle,
            button.dataset.questionAnswer,
            button.dataset.questionTags,
            button.dataset.questionText,
            button.textContent
          ].join(' ').toLowerCase();
          const visible = !tokens.length || tokens.every((token) => haystack.includes(token));
          button.hidden = !visible;
          if (visible) {
            visibleCount += 1;
            if (!firstVisible) firstVisible = button;
          }
        });
        if (empty) empty.hidden = visibleCount > 0;
        if (submit) submit.textContent = visibleCount > 0 ? 'Submit new question' : (submit.dataset.emptySubmitLabel || 'Submit this question');
        const active = suggestions.find((button) => button.classList.contains('is-active') && !button.hidden);
        if (active) activate(active);
        else if (firstVisible) activate(firstVisible);
      };

      suggestions.forEach((button) => {
        button.setAttribute('aria-pressed', String(button.classList.contains('is-active')));
        button.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopImmediatePropagation();
          preserveScroll(() => activate(button));
        }, true);
      });
      input?.addEventListener('input', () => preserveScroll(filterQuestions));
      filterQuestions();
    });
  };

  const bindCollectionFilters = () => {
    all('[data-collection-filter-bar]').forEach((bar) => {
      if (bar.dataset.reviewCollectionFilterBound === 'true') return;
      bar.dataset.reviewCollectionFilterBound = 'true';
      const section = bar.closest('.product-index-section') || document;
      const cards = all('[data-collection-product-group]', section);
      const buttons = all('[data-collection-filter]', bar);
      const filterParam = bar.dataset.collectionFilterParam || '';
      const applyFilter = (value) => {
        const activeValue = value || 'all';
        buttons.forEach((button) => {
          const selected = (button.dataset.collectionFilter || 'all') === activeValue;
          button.classList.toggle('is-active', selected);
          button.setAttribute('aria-pressed', String(selected));
        });
        cards.forEach((card) => {
          const group = card.dataset.collectionProductGroup || 'all';
          card.hidden = activeValue !== 'all' && group !== activeValue;
        });
      };
      buttons.forEach((button) => {
        button.addEventListener('click', (event) => {
          event.preventDefault();
          const value = button.dataset.collectionFilter || 'all';
          preserveScroll(() => applyFilter(value));
          if (filterParam) {
            const url = new URL(window.location.href);
            if (value === 'all') url.searchParams.delete(filterParam);
            else url.searchParams.set(filterParam, value);
            window.history.replaceState(window.history.state, '', url.href);
          }
        });
      });
      const active = buttons.find((button) => button.classList.contains('is-active')) || buttons[0];
      const requestedFilter = filterParam ? new URL(window.location.href).searchParams.get(filterParam) : null;
      const requestedFilterIsValid = buttons.some((button) => (button.dataset.collectionFilter || 'all') === requestedFilter);
      applyFilter(requestedFilterIsValid ? requestedFilter : (active?.dataset.collectionFilter || 'all'));
    });
  };

  const boot = () => {
    installMobileControlGuard();
    installPdpAnchorLegibilityGuard();
    bindHomeModeAftercare();
    bindCompareExpandAll();
    bindProductMediaSwipe();
    bindProductReadingSurfaceSticky();
    bindHeaderDropdowns();
    bindSpecDecisionPanel();
    bindProductQuestionPanel();
    bindCollectionFilters();
    const active = one('[data-category-tab].is-active, [data-category-tab].selected');
    syncHeroSecondary(active?.dataset.categoryTab || 'hoops');
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
  window.addEventListener('pageshow', boot);
})();
